import { HttpContextToken } from '@angular/common/http';

/**
 * Wenn auf `true` gesetzt, wird bei einem HTTP-Fehler kein Fehlerdialog angezeigt.
 * Standardmäßig ist der Fehlerdialog aktiviert (false = Dialog wird gezeigt).
 *
 * Verwendung (um Dialog zu unterdrücken):
 * @example
 *   import { HttpContext } from '@angular/common/http';
 *   import { SILENT_HTTP_ERROR } from '../services.module/http-error.token';
 *
 *   this.http.get(url, {
 *       context: new HttpContext().set(SILENT_HTTP_ERROR, true)
 *   });
 *
 * Oder in generierten API-Services über den `context`-Parameter:
 * @example
 *   this.myApiService.getSomething(id, undefined, new HttpContext().set(SILENT_HTTP_ERROR, true));
 */
export const SILENT_HTTP_ERROR = new HttpContextToken<boolean>(() => false);

